export const getWordInAccusativeCase = (word: string): string =>
  word
    .replace('кая', 'кую')
    .replace(/(ка)(\s+|$)/g, 'ку$2')
    .replace('ква', 'кву')
    .replace(/(ая)/g, 'ую')
    .replace(/(а)$/g, 'у')
    .replace(/(я)$/g, 'ю')

export const getWordInDativeCase = (word?: string): string =>
  word
    ? word
        .replace(/(ая)/g, 'ой')
        .replace(/(а)$/g, 'е')
        .replace(/(я)$/g, 'е')
        .replace(/(ь)$/g, 'ю')
        .replace(/(ый)$/g, 'ому')
        .replace(/(к)(\s+|$)/g, 'ку$2')
        .replace(/(с)$/g, 'су')
        .replace(/(ий)$/g, 'ому')
        .replace(/(ён)(\s+|$)/g, 'ьну$2')
        .replace(/(х)$/g, 'ху')
        .replace(/(р)$/g, 'ру')
    : ''
